import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // If user data was passed from AuthCallback, skip loading check
  if (location.state?.user) {
    return children;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#1a1c1b] flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-[#7dd3fc] animate-spin mx-auto mb-4" />
          <p className="text-[#7dd3fc] text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
